module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/16a porterhouse + T-bone steak.jpg";